<script>
    import { createEventDispatcher } from "svelte";
    import Icon from "$lib/UI/Icon.svelte";
    export let id = undefined;
    export let title = undefined;
    export let description = undefined;
    export let icon = undefined;
    export let first = false;
    export let action = undefined;
    export let top = false;

    let menuVisible = false;

    const dispatch = createEventDispatcher();

    function doActionSelect(event) {
        dispatch("select", { id: id, action: action });
    }

    function truncateDescription(description) {
        if (!!description) {
            let length = 100;

            return description.length > length
                ? description.substring(0, length) + "..."
                : description;
        }
        return "";
    }

    function empty(s) {
        if (!s) {
            return "";
        }
        return s;
    }
</script>

<div
    class="actionlistitem"
    class:first-actionlistitem={first}
    class:top-actionlistitem={top}
>
    <div class="icon">
        <Icon style="light" {icon} size="larger" />
    </div>

    <div class="listitem" on:click={doActionSelect}>
        <div class="listline topline">
            <span class="title">{empty(title)}</span>
        </div>
        <div class="listline">
            <span class="description">{truncateDescription(description)}</span>
        </div>
    </div>
    <slot />
</div>

<style>
    .icon {
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0 8px 0 0;
        width: 45px;
    }

    .actionlistitem:hover {
        background-color: var(--background-select);
        cursor: pointer;
    }

    .listitem:active {
        background-color: var(--background-select);
    }

    .actionlistitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: small;
        border-top: gray solid 1px;
    }

    .top-actionlistitem {
        flex-direction: column;
        align-items: center;
    }

    .first-actionlistitem {
        border-top: initial;
    }

    .topline {
        padding-top: 5px;
    }

    .listitem {
        padding: 5px;
        width: 100%;
        padding: 0 0;
    }

    .listline {
        display: flex;

        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }

    .top-actionlistitem .listline {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }

    .title {
        margin-bottom: 0.1rem;
        font-weight: bold;
    }

    .description {
        padding-bottom: 0.5rem;
    }
</style>
